export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },

    isMobileNavigation() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
